<template>
    <swiper
        :effect="'fade'" 
        :modules="modules" 
        :autoplay="{
          delay: 2000,
        }"        
        :speed="2000"
        :loop="true"
        >
      <swiper-slide v-for="(item, index) in cardImages" :key="index">        
        <link rel="preload" :fetchpriority="index==0?'high':'low'" as="image" :href="item">
        <picture>
            <img 
                :class="opac"
                id="cover-image" 
                :width="isMobile?350:1440"
                :height="isMobile?250:715"
                :src="item" 
                :alt="modelName"
                :fetchpriority="index==0?'high':'low'"
            />
        </picture>
      </swiper-slide>
    </swiper>
</template>
<script lang="ts">
import { isMobile } from "views/shared/utils/mobile";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';

// import required modules
import { EffectFade, Autoplay } from 'swiper';

export default {
    name: 'CarouselEssayMain',
    props: ['cardImages', 'modelName'],    
    components: {
        Swiper,
        SwiperSlide
    },
    setup() {
        return {
            modules: [EffectFade, Autoplay],
        };
    },
    data() {
        return {
            opac: 'opacity-0',
            isMobile: isMobile(),            
        }  
    },
    mounted() {
        this.opac = 'opacity-1'
    }
};
</script>

<style scoped lang="css">
.cover__image img {
    width: 100%;
    height: auto;
}
</style>